import type { IComment } from '~/components/entity/comment/types'

export const COMMENTS_MAX_DEPTH = 3

export interface ICommentWithAuthor extends IComment {
  replies?: ICommentWithAuthor[]
}

export interface ICommentFormData {
  text: string
  parent_id?: number | null
}

export interface ICommentsWidgetProps {
  commentableType: string
  commentableId: number
  sortOrder?: 'newest' | 'oldest'
}
